import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { EmptyState } from '@/ui/primitives.js';

export function NotFoundPage(): ReactNode {
  return (
    <EmptyState
      title="Nothing here"
      message="That page does not exist."
      action={
        <Link className="text-sm font-semibold underline" to="/capture">
          Go to sessions
        </Link>
      }
    />
  );
}
